import produce from "immer";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import {
  setForm,
  startLoadFormListByProjectId,
} from "../../actions/formListAction";
import { startEditProtoType } from "../../actions/protoTypeAction";
import { getForms } from "../../selectors/appSelectors";
import { getPrototype } from "../../selectors/protoTypeSelector";
import FormCardComponent from "./utils/formCardComponent";
import PrototypeCreateArea from "./utils/prototypeCreationAreaComponent";
import protoTypeService from "../../services/prototypeService";
import { uuid } from "uuidv4";
import { useAlert } from "react-alert";
import {
  Alert,
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { baseUrl, Modes } from "../../utils/constants";
import { toast } from "react-toastify";
import { setActivePath } from "../../actions/activePathAction";
import PorotoTypeLeftPanelComponent from "./utils/prototypeLeftPanelComponent";
import { ItemTypes } from "../../utils/itemTypes";
import { useDrop } from "react-dnd";
import { Project } from "../../models/projectModel";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { ModalAttributeModel } from "../../models/modalAttributeModel";
import { AlertAttributeModel } from "../../models/alertAttributeModel";
import { cssStyle } from "../../models/cssStyleModel";
import { AppState } from "../../reducers/rootReducer";
import { setSession } from "../../actions/sessionListAction";

type TParams = { id: string };
export interface FormModel {
  id: String;
  projectId: String;
  name: string;
  type: string;
  groupId: string;
  modalAttribute: ModalAttributeModel;
  alertAttribute: AlertAttributeModel;
  saveAs?: string;
  cssStyles: [cssStyle];
  createdTime: string;
  lastUpdatedTime: string;
}

const PrototypeComponent = ({ match }: RouteComponentProps<TParams>) => {
  const dispatch = useDispatch();
  // const formList = useSelector(getForms);
  const formList = useSelector((state: AppState) => state.formList);
  const prototypeState = useSelector(getPrototype);
  const alert = useAlert();
  const [show, setShow] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [create, setCreate] = useState(false);
  const [pathId, setPathId] = useState("");
  const [prototypeName, setPrototypeName] = useState("");
  const [protoTypeList, setProtoTypeList] = useState([]);
  const [project, setProject] = useState<Project>();
  const ref = useRef<HTMLDivElement>(null);
  const session = useSelector((state: AppState) => state.session);

  const [leftPanal, setLeftPanal] = useState(false);

  const changeLeftPanalState = () => {
    setLeftPanal((leftPanal) => !leftPanal);
    console.log(leftPanal);
  };
  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept: ItemTypes.FORM_MOVE,
    drop(item: any, monitor) {
      const didDrop = monitor.didDrop();
      if (didDrop) {
        return;
      }
      console.log(item.index);
      const newPrototypeState = produce(prototypeState, (draft) => {
        draft.formList.splice(item.index, 1);
      });
      console.log(newPrototypeState);
      dispatch(startEditProtoType(newPrototypeState));
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  });

  drop(ref);

  useEffect(() => {
    async function loadProtoTypes() {
      const response = await protoTypeService.getMetaDataByProject({
        projectId: match.params.id,
      });
      setProtoTypeList(response.data.data.prototypeList);
      setProject(response.data.data.project);
      let newSessionState = produce(session, (draft) => {
        draft.selectedMode = Modes.PROTOTYPE;
      });
      dispatch(setSession(newSessionState));
    }
    loadProtoTypes();
    dispatch(startLoadFormListByProjectId(match.params.id));
    const newPrototypeState = produce(prototypeState, (draft) => {
      draft.projectId = match.params.id;
      // draft.formList = [];
    });
    dispatch(startEditProtoType(newPrototypeState));
    dispatch(setActivePath("/create"));
    return () => {
      dispatch(setForm([]));
      dispatch(setActivePath("/"));
    };
  }, []);

  const renderFormList = () => {
    const filteredFormList = formList.filter(
      (form) => form.groupId === selectedGroupId
    );
    console.log(filteredFormList);
    return filteredFormList.map((form) => {
      return <FormCardComponent form={form} />;
    });
  };

  const resetProtoType = async () => {
    const startForm = {} as FormModel;
    const lastForm = {} as FormModel;
    startForm.id = "Start";
    startForm.name = "Start";
    lastForm.id = "End";
    lastForm.name = "End";
    const newPrototypeState = produce(prototypeState, (draft) => {
      draft.id = "";
      draft.formList = [startForm, lastForm];
    });
    dispatch(startEditProtoType(newPrototypeState));
  };

  const createProtoType = async () => {
    setCreate(false);
    let id = uuid();
    const newPrototypeState = produce(prototypeState, (draft) => {
      draft.id = id;
      draft.name = prototypeName;
    });
    const { data } = await protoTypeService.createProtoType(newPrototypeState);
    const response = await protoTypeService.getProtoTypesByProject({
      projectId: match.params.id,
    });
    setProtoTypeList(response.data.data.prototypeList);
    setPathId(data.data.id);
    setShow(true);
  };

  return (
    <>
      {/* <Alert show={show} variant="success" onClose={() => setShow(false)} dismissible>
        <Alert.Heading>Create Successfully</Alert.Heading>
        <p>
          Path to prototype <Alert.Link href={`${baseUrl}prototype/view/${pathId}`} target="_blank">{`${baseUrl}prototype/view/${pathId}`}</Alert.Link>
        </p>
      </Alert> */}
      <Modal
        size="lg"
        isOpen={show}
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header className="theam-btn" closeButton>
          <Modal.Title>Prototype Link</Modal.Title>
        </Modal.Header>
        <Modal.Body className="theam-btn">
          <p>Path to Prototype</p>
          <div className="input-group">
            <a
              className="form-control"
              rel="noopener , noreferrer"
              href={`http://${baseUrl}preview/prototype-render/${pathId}`}
              target="_blank"
            >{`${baseUrl}preview/prototype-render/${pathId}`}</a>
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(
                    `${baseUrl}preview/prototype-render/${pathId}`
                  );
                  toast.success("Copied to clipboard", {
                    position: "top-right",
                    autoClose: 2 * 1000,
                  });
                }}
              >
                <i className="fa fa-copy" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        isOpen={create}
        show={create}
        onHide={() => {
          setCreate(false);
        }}
      >
        <Modal.Header className="theam-btn" closeButton>
          <Modal.Title>Prototype Create</Modal.Title>
        </Modal.Header>
        <Modal.Body className="theam-btn">
          <div className="input-group mb-3">
            <input
              onChange={(e) => {
                setPrototypeName(e.target.value);
              }}
              type="text"
              className="form-control theam-btn"
              placeholder="Prototype Name"
              aria-label="Prototype Name"
              aria-describedby="basic-addon2"
            />
            <div className="input-group-append">
              <button
                onClick={() => {
                  createProtoType();
                }}
                className="btn btn-outline-secondary"
                type="button"
              >
                Create
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div ref={ref} className="container-fluid">
        <div className="row">
          {!leftPanal ? (
            <div className="col-sm-1 noPadding theam-dark-panel">
              <div className="prototype-list-title-area align-left pl-2 pt-15">
                <span>
                  <i className="fa fa-eye"></i>{" "}
                </span>
                <span>Prototypes</span>{" "}
                <span>
                  <button
                    className="btn prototype-list-area-hide-btn btn-dark theam-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      changeLeftPanalState();
                    }}
                  >
                    <FiChevronLeft />
                  </button>{" "}
                </span>
              </div>
              <PorotoTypeLeftPanelComponent prototypeList={protoTypeList} />
            </div>
          ) : (
            <div>
              {/* <span><i className="fa fa-eye"></i> </span>  */}

              <span>
                <button
                  className="btn prototype-list-area-show-btn btn-dark theam-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    changeLeftPanalState();
                  }}
                >
                  <FiChevronRight />
                </button>
              </span>
            </div>
          )}
          <div
            className={`pl-0 pr-0 ${!leftPanal ? "col-sm-11" : "col-sm-12"}`}
          >
            <div className="row  prototype-list-title-area mr-0 justify-content-between">
              <div className="col-sm-6 pt-15 align-left">
                <span className={`${leftPanal ? "pl-70" : "pl-3"}`}>
                  Prototype Creation
                </span>
              </div>
              <div className="col-sm-3 align-right pt-2">
                <button
                  className="btn mr-2 btn-primary"
                  onClick={() => resetProtoType()}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => setCreate(true)}
                >
                  Create
                </button>
              </div>
            </div>
            <div className="row pt-2 ml-0 mr-0 theam-dark-panel">
              <div className="col-2">
                <Form.Group as={Row} controlId="firstName">
                  {/* <Form.Label column sm={4}>Select Group</Form.Label> */}
                  <Col sm={10}>
                    <Form.Control
                      className="custom-select prototype-dropdown"
                      as="select"
                      value={selectedGroupId}
                      onChange={(e) => {
                        setSelectedGroupId(e.target.value);
                      }}
                    >
                      <option value="">Default Group</option>
                      {project?.groups.map((group: any, index: number) => {
                        return (
                          <option key={`group-${group.id}`} value={group.id}>
                            {group.name}
                          </option>
                        );
                      })}
                      ;
                    </Form.Control>
                  </Col>
                  <Col sm={1}>
                    <i className="fa fa-angle-double-right group-icon"></i>
                  </Col>
                </Form.Group>
              </div>
              <div className="col-10 form-list pb-2">{renderFormList()}</div>
            </div>
            <PrototypeCreateArea />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrototypeComponent;
